<template>
  <el-container class="layout">
    <el-aside width="220px" class="aside">
      <div class="logo">
        <img src="/static/logo.png" alt="">
        <span>豆瓜租赁</span>
      </div>
      <el-menu :default-active="$route.path" router background-color="#1a3c23" text-color="#bfcbd9" active-text-color="#66dd7a">
        <template v-for="route in routes">
          <el-submenu v-if="route.children && route.children.length > 1" :key="route.path" :index="route.path">
            <template slot="title">
              <i :class="route.meta.icon"></i>
              <span>{{ route.meta.title }}</span>
            </template>
            <el-menu-item v-for="c in route.children" :key="c.path" :index="route.path + '/' + c.path">
              {{ c.meta.title }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :key="route.path" :index="route.path + '/' + route.children[0].path">
            <i :class="route.meta.icon"></i>
            <span slot="title">{{ route.meta.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <span class="title">{{ $route.meta.title }}</span>
        <div class="user">
          <span>{{ admin.nickname || admin.username }}</span>
          <el-button type="text" @click="logout">退出</el-button>
        </div>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import router from '@/router'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  computed: {
    ...mapGetters(['admin']),
    routes() {
      return router.options.routes.filter(r => !r.hidden && r.meta && r.children && r.children.length)
    }
  },
  methods: {
    logout() {
      this.$store.commit('LOGOUT')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped lang="scss">
.layout { height: 100vh; }
.aside { background: #1a3c23; }
.logo { height: 64px; display: flex; align-items: center; justify-content: center; color: #fff; border-bottom: 1px solid rgba(255,255,255,0.1); }
.logo img { width: 36px; height: 36px; border-radius: 50%; margin-right: 10px; }
.logo span { font-size: 18px; font-weight: 600; }
.header { background: #fff; display: flex; align-items: center; justify-content: space-between; box-shadow: 0 2px 10px rgba(0,0,0,0.04); }
.title { font-size: 18px; font-weight: 600; color: #333; }
.user span { margin-right: 16px; color: #666; }
.main { background: #f3f6f8; }
</style>
